<template>
  <div>
    <h4 class="mb-4">{{ $t('message.credit.whaToExpect') }}</h4>
    <ul class="list-unstyled">
      <li v-for="(step, index) in steps" :key="index" class="d-flex step-item">
        <div class="mr-3 step-wrapper">
          <div class="step-circle">
            <span v-if="step.completed"
              ><img data-cy="checkIcon" src="@/assets/fa/check-mark.svg" alt="checkmark icon"
            /></span>
            <span v-else class="step-number">{{ index + 1 }}</span>
          </div>
        </div>
        <div class="flex-grow-1">
          <div
            class="d-flex justify-content-between align-items-center"
            @click="toggle(index)"
            :style="!step.completed ? 'cursor: pointer' : ''"
          >
            <span class="font-weight-bold d-flex align-items-center">
              <img
                v-if="step.equifax"
                class="mr-2"
                :src="require(`@/assets/credit-bureaus/Equifax-Logo.svg`)"
                alt="Equifax"
                width="80"
                height="16"
              />
              {{ step.title }}
              <span class="ml-2" v-if="!step.completed"
                ><img
                  :class="step.expanded ? 'is-open' : ''"
                  src="@/assets/fa/chevron-down.svg"
                  alt="chevron"
                  width="14"
                  height="14"
              /></span>
            </span>
            <small v-if="step.time" class="span-time"
              ><img class="clock-img" src="@/assets/clock-grey.svg" alt="clock-img" /> {{ step.time }}
            </small>
          </div>
          <div v-if="step.expanded || step.completed" class="mt-3 mb-4 small" v-html="step.description"></div>
        </div>
      </li>
    </ul>
    <h4 class="mt-2">{{ $t('message.credit.disclaimer.noAffectScore') }}</h4>
  </div>
</template>

<script>
import tdLogo from '@/assets/prequal-lenders/TD-logo.svg';

export default {
  name: 'CreditOnboardingSteps',
  data() {
    return {
      steps: [
        {
          title: this.$t('message.credit.personalInformation.header'),
          time: this.$t('message.credit.personalInformation.time'),
          description: this.$t('message.credit.personalInformationCreditText'),
          expanded: false,
        },
        {
          title: this.$t('message.credit.idVerification.header'),
          time: this.$t('message.credit.idVerification.time'),
          description: this.$t('message.credit.application.equifaxCreditBureauCard'),
          equifax: true,
          expanded: false,
        },
        {
          title: this.$t('message.credit.incomeAndDebt.header'),
          time: this.$t('message.credit.incomeAndDebt.time'),
          description: this.$t('message.credit.incomeAndDebtText'),
          expanded: false,
        },
        {
          title: this.$t('message.credit.preQualificationResults.header'),
          time: '',
          description: `<div class="mt-3 small d-flex align-items-start">
    <img
      class="mr-2"
      src="${tdLogo}"
      alt="TD Auto Finance"
      width="40"
    />
    See if you pre-qualify for financing with TD Auto Finance.</div>
  `,
          completed: true,
        },
      ],
    };
  },
  methods: {
    toggle(index) {
      if (this.steps[index].description) {
        this.steps[index].expanded = !this.steps[index].expanded;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.step-item {
  position: relative;
  padding-left: 12px;
  min-height: 55px;
  // vertical line
  .step-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    // draw the vertical line
    &::after {
      content: '';
      position: absolute;
      top: 30px;
      left: 50%;
      transform: translateX(-50%);
      width: 4px;
      height: calc(100% - 30px);
      background-color: #dae2ea;
      z-index: 0;
    }
  }
  // hide the line for the last step
  &:last-child .step-wrapper::after {
    display: none;
  }
}
.step-circle {
  height: 30px;
  min-width: 30px;
  float: right;
  position: relative;
  border-radius: 50%;
  line-height: 27px;
  color: #dae2ea;
  border: 1px solid #dae2ea;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  text-align: center;
  .step-number {
    color: #6d7783;
    font-size: 14px;
    font-weight: 400;
  }
}
.equifax-logo {
  height: 18px;
}
.td-logo {
  height: 20px;
}
.clock-img {
  margin: 0 2px 2px 0;
}
.span-time {
  width: 60px;
}
img.is-open {
  -webkit-transform: rotate(-180deg);
  transform: rotate(-180deg);
}
</style>
